const ACTION = {
    UPDATE_GLOBAL_TOAST: 'UPDATE_GLOBAL_TOAST',
    UPDATE_GLOBAL_TOAST_ONLY: 'UPDATE_GLOBAL_TOAST_ONLY',
}

export default ACTION;
